import {getField, updateField} from 'vuex-map-fields';
import ConsumerModule from '@/commonFunction/consumerModule'

let current_module = new ConsumerModule('/ws/calendar_date/vacation/');

const state = {
    ...current_module.state,
    options: {
        page: 1,
        itemsPerPage: -1,
        sortBy: ['human_user__employee_number'],
        sortDesc: [true],
        multiSort: false,
        mustSort: false,
        descending: true,
    },
};

const getters = {
    ...current_module.getters,
    getColumns(state) {
        let columns = [
            {text: 'User', value: 'human_user', sortable: false, filterable: false, divider: true,},
            {text: 'Department', value: 'department', sortable: false, filterable: false, divider: true,},
            {text: 'Current vacation', value: 'current_vacation', sortable: false, filterable: false, divider: true,},
        ]
        if (state.itemListCommon && state.itemListCommon.selected_weeks)
            for (let row of state.itemListCommon.selected_weeks)
                columns.push({text: row.start_week_date, value: row.start_week_date, sortable: false, filterable: false, divider: true,})
        return columns
    },
};
const actions = {
    ...current_module.actions,
};
const mutations = {
    ...current_module.mutations,
};

export default {
    modules: {
        CalendarVacationTable: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}